<template>
    <div v-if="bodyShow"  class="ceping79-main">
        <div class="header">
            <div class="logot">
            <div class="top">人才</div>
            <div class="bottom">加速器</div>
            </div>
            <div class="right">人才加速器</div>
        </div>
        <img class="qrcode" src="@a/ceping80/qrcode.png" alt="" />
        <p class="text">长按识别二维码关注此公众号</p>
    </div>
</template>

<script>
import { ceping80_support_user } from "@/api/measurement";
export default {
    data(){
        return{
          bodyShow:false
        }
    },
    methods:{
      pullData(){
        let q = this.$route.query;
        if (q.share_uid) {
          //调用加载中
          this.$emit("loadingHandle", true, "拼命加载中...");
          ceping80_support_user({
            share_uid: q.share_uid,
          }).then((data) => {
            if (data.code == "10002") {
              //关闭加载中
              this.$emit("loadingHandle", false);
              this.$toast(data.msg);
              return;
            }
            document.title = '海岛历险';
            this.bodyShow = true;
            //关闭加载中
            this.$emit("loadingHandle", false);

          });
        }else{
          this.$toast('当前地址确少参数！');
          return;
        }
      }
    },
    created(){
      this.pullData();
    }
}
</script>

<style lang="scss" scoped>
// 关注二维码
.ceping79-main {
  border-radius: 15px;
  background-color: #ffffff;
  padding: 40px 30px;
  margin: 100px 30px;
  text-align: center;
  .header {
    display: flex;
    align-items: center;
    margin-bottom: 80px;
    .logot {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: #eb5032;
      text-align: center;
      color: #ffffff;
      padding: 15px 10px;
      .top {
        font-size: 42px;
        letter-spacing: 4px;
      }
      .bottom {
        font-size: 22px;
        letter-spacing: 10px;
      }
    }
    .right {
      margin-left: 30px;
      font-size: 30px;
      color: #333333;
      letter-spacing: 4px;
    }
  }
  .qrcode {
    width: 500px;
    margin-bottom: 50px;
  }
  .text {
    font-size: 34px;
    color: #333333;
    text-align: center;
    margin-bottom: 50px;
  }
}
</style>